import React, { Component } from 'react';
import ControlItem from './control_item';
import './fresh.css';
import { machine_service } from "../service/mahcine.service";
import { Button, Modal, Slider, Toast } from "antd-mobile"

class OperationPanel extends Component {
    constructor(props) {
        super(props);
        this.power_click = this.power_click.bind(this);
        this.speed_panel = this.speed_panel.bind(this);
        this.mode_panel = this.mode_panel.bind(this);
        this.light_panel = this.light_panel.bind(this);
        this.heat_panel = this.heat_panel.bind(this);
        this.local_volume = this.local_volume.bind(this);
        this.mode_operate = this.mode_operate.bind(this);
        this.volume = this.volume.bind(this);
        this.lock_operate = this.lock_operate.bind(this);
        this.obtain_hideVolumeIfOpen = this.obtain_hideVolumeIfOpen.bind(this);
        this.obtain_lightPanelOnOff = this.obtain_lightPanelOnOff.bind(this);
        this.light_panel_onOff = this.light_panel_onOff.bind(this);
        this.state = {
            min_volume: '',
            max_volume: '',
            min_light: '',
            max_light: '',
            step: '',
            show_volume: false,
            show_mode: false,
            show_light: false,
            show_heat: false,
            show_lightPanel: false, //该设备的屏显是否拥有开关属性
            lightPanelOnOff: true,  //该设备的屏显开关
            volume_loading: false  // 风量调节加载状态
        }
    }

    componentDidMount() {
        this.check_qrcode(this.props.qrcode)
    }
    // componentDidUpdate(prevProps) {
    //     if (prevProps.volume !== this.props.volume) {
    //         console.log(
    //             "%c父组件更新了 volume!",
    //             "color: red; font-size: 16px;",
    //             "旧值:", prevProps.volume,
    //             "新值:", this.props.volume
    //         );
    //         // Toast.fail('风量调节失败，请重试', 2);
    //         console.trace("volume 被父组件覆盖的调用栈如下：");
    //     }
    // }
    check_qrcode = (qrcode) => {

        machine_service.check_exist(qrcode).then(response => {
            if (response.responseCode === 'RESPONSE_OK') {
                let modelId = response.data[0].modelId;
                this.obtain_hideVolumeIfOpen();
                this.obtain_lightPanelOnOff();
                this.init_control_option(modelId);
            }
        })
    }

    /**
     * 用于按钮的风量变动
     * @param  delta 
     */
    adjustVolume = (delta) => {
        const { min_volume, max_volume } = this.state;
        let newValue = this.props.volume + delta;

        // 不超过上下限
        if (newValue < min_volume) newValue = min_volume;
        if (newValue > max_volume) newValue = max_volume;

        // 本地更新 UI
        this.local_volume(newValue);

        // 执行后端调节逻辑
        this.volume(newValue);
    }

    //隐藏风量是否开启
    obtain_hideVolumeIfOpen = () => {
        machine_service.obtain_turboVolume_status(this.props.qrcode).then(response => {
            if (response.responseCode === 'RESPONSE_OK') {
                this.props.getHideVolumeIfOpen(response.data.turboVolumeStatus)
                console.log(this.props.hideVolumeIfOpen)
            }
        })
    }

    //获取基本风量区间和屏显范围
    init_control_option = (modelId) => {

        machine_service.obtain_volume_range(modelId).then(response => {

            if (response.responseCode === 'RESPONSE_OK') {
                this.setState({ min_volume: response.data[0].minVolume, max_volume: response.data[0].maxVolume })
            }
        })

        machine_service.obtain_light_range(modelId).then(response => {
            if (response.responseCode === 'RESPONSE_OK') {
                this.setState({
                    min_light: response.data[0].minLight,
                    max_light: response.data[0].maxLight,
                    step: response.data[0].step
                })
            }
        })
    }

    startAdjustVolume = () => {
        this.props.setAdjustingVolume(true);
    };
    //电源点击
    power_click() {
        let machine_status = this.props.machine_status;
        // console.log(machine_status)
        if (machine_status.power_status) {
            machine_service.operate(this.props.qrcode, 'power', 'off');
            machine_status.power_status = false
        } else {
            machine_service.operate(this.props.qrcode, 'power', 'on');
            machine_status.power_status = true
        }
        this.props.changeMachineStatus(machine_status);
    }
    //风量点击
    speed_panel = () => {
        if (this.props.online) {
            //是否开启隐藏风量
            if (this.props.hideVolumeIfOpen) {
                machine_service.obtain_turboVolume_range(this.props.qrcode).then(response => {
                    if (response.responseCode === 'RESPONSE_OK') {
                        this.setState({ max_volume: response.data.turboVolume })
                    }
                })
            }

            this.setState({ show_volume: !this.state.show_volume })

        }
    }
    //风量调节
    // volume = (e) => {
    //     this.local_volume(e)
    //     machine_service.volume(this.props.qrcode, e);

    // }
    //风量调节带加载状态
    volume = (e) => {
        this.setState({ volume_loading: true });
        this.props.setVolumeLock();
        machine_service.volume(this.props.qrcode, e).then(response => {
            // 后端返回成功时立即关闭加载状态
            if (response.responseCode === 'RESPONSE_OK') {
                setTimeout(() => {
                    this.setState({ volume_loading: false });
                }, 500);
                // console.log('Change success!')
                // this.setState({ volume_loading: false });
                this.local_volume(e);
            } else {
                // 失败时3秒后关闭加载状态
                setTimeout(() => {
                    this.setState({ volume_loading: false });
                }, 3000);
                // console.log('Change failed!')
                Toast.fail('风量调节失败，请重试', 2);
            }
        }).catch(error => {
            // // 请求异常时3秒后关闭加载状态
            // console.error('风量调节失败:', error);
            Toast.fail('风量调节失败，请重试', 2);
            setTimeout(() => {
                this.setState({ volume_loading: false });
            }, 3000);
        });
    }


    local_volume = (e) => {
        let machine_status = this.props.machine_status;
        machine_status.volume = e;
        // this.props.volume = e;
        this.props.changeMachineStatus(machine_status);
        // console.log('onChangeComplete: ', machine_status.volume)
    }

    //模式点击
    mode_panel = () => {

        if (this.props.online) {
            this.setState({ show_mode: !this.state.show_mode })
        }
    }
    //模式选择
    mode_operate = (mode_name) => {
        let machine_status = this.props.machine_status;
        machine_status.work_mode = mode_name;
        this.props.changeMachineStatus(machine_status);
        machine_service.operate(this.props.qrcode, 'mode', mode_name);
    }

    //屏显点击
    light_panel = () => {

        if (this.props.online) {
            this.setState({ show_light: !this.state.show_light })
        }
    }

    //屏显开关
    light_panel_onOff = () => {
        if (this.props.online) {
            let machine_status = this.props.machine_status;

            if (machine_status.panel == 1) {
                machine_service.operate(this.props.qrcode, 'panel', 'off');
                machine_status.panel = 0
                this.setState({
                    lightPanelOnOff: false
                })
            } else {
                machine_service.operate(this.props.qrcode, 'panel', 'on');
                machine_status.panel = 1
                this.setState({
                    lightPanelOnOff: true
                })
            }
            this.props.changeMachineStatus(machine_status);

        }


    }

    //是否拥有屏显开关属性
    obtain_lightPanelOnOff() {

        machine_service.obtain_machine_status(this.props.qrcode).then(response => {
            if (response.responseCode === 'RESPONSE_OK') {
                if (response.data.panel != undefined) {
                    this.setState({
                        show_lightPanel: true,
                        lightPanelOnOff: response.data.panel === 1 ? true : false
                    })
                }
            }
        })
    }

    local_light = (e) => {
        let machine_status = this.props.machine_status;
        machine_status.light = e;
        this.props.changeMachineStatus(machine_status);
    }

    light = (light) => {
        machine_service.light(this.props.qrcode, light);
    }

    //辅热点击
    heat_panel = () => {
        if (this.props.online) {
            this.setState({ show_heat: !this.state.show_heat })
        }
    }

    //童锁调节
    lock_operate = () => {
        if (this.props.online) {
            let machine_status = this.props.machine_status;
            if (this.props.lock === 0) {
                machine_status.lock = 1;
                machine_service.operate(this.props.qrcode, 'lock', 'on');
            } else {
                machine_status.lock = 0;
                machine_service.operate(this.props.qrcode, 'lock', 'off');
            }
            this.props.changeMachineStatus(machine_status);
        }
    }

    render() {
        // console.log("父组件传来的 volume =", this.props.volume);
        const area_desc = {
            marginTop: `1rem`
        }

        const btnStyle = {
            width: '32px',
            height: '32px',
            marginLeft: '1rem',
            marginRight: '1rem',
            borderRadius: 10,
            border: 'none',
            // background: '#fff',
            background: '#fff',
            fontSize: '20px',
            lineHeight: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        };

        const config_panel_area = {
            height: `4.5rem`,
            margin: `3rem 15% 0rem 15%`
        }

        const min_volume = {
            // marginLeft: `7.5%`,
            textAlign: `left`,
            width: `30%`,
            float: `left`
        }

        const current_volume = {
            width: `40%`,
            float: `left`,
        }

        const max_volume = {
            // marginRight: `7.5%`,
            textAlign: `right`,
            width: `30%`,
            float: `left`
        }

        const volume_area = {
            margin: `0 0 2rem 5rem`,
            height: `2rem`,
        }

        const mode_operation_area = {
            width: `85%`,
            margin: `1rem 7.5%`,
            textAlign: `center`
        }

        const turboVolume_area = {
            display: "flex",
        }
        // console.log(this.props)
        let heat_mode_list = this.props.heat_mode_list;
        let operation_list = heat_mode_list ? heat_mode_list.map((item, index) => {
            return (<Button type={this.props.heat == index ? 'primary' : 'ghost'} inline size="small"
                className='am-button-borderfix'
                style={{ margin: '0 1.5rem' }} onClick={() => {
                    {
                        if (this.props.heat !== index) {
                            let machine_status = this.props.machine_status;
                            machine_status.heat = index;
                            this.props.changeMachineStatus(machine_status);
                            machine_service.operate(this.props.qrcode, 'heat', item.operator);
                        }
                    }
                }}>{item.name}</Button>)
        }) : []

        let mode_name = 'fa fa-hand-paper-o';
        if (this.props.work_mode === 'sleep') {
            mode_name = 'fa fa-moon-o';
        }
        if (this.props.work_mode === 'auto') {
            mode_name = 'fa fa-refresh';
        }

        let heat_class = []
        if (heat_mode_list.length == 3) {
            heat_class = ['fa fa-thermometer-0', 'fa fa-thermometer-2', 'fa fa-thermometer-4'];
        } else {
            heat_class = ['fa fa-thermometer-0', 'fa fa-thermometer-4'];
        }

        return (
            <div className="operation_panel_1">
                <div className="operation_panel_row">
                    <div className="operation_panel_item" onClick={this.power_click}>
                        <ControlItem src="fa fa-power-off" text="电源" open={this.props.online} />
                    </div>
                    <div className="operation_panel_item" onClick={this.speed_panel}>
                        <ControlItem src="fa fa-recycle" text="风量" open={this.props.online && this.props.volume !== 0} />
                        <Modal popup visible={this.state.show_volume} animationType="slide-up" onClose={() => this.setState({ show_volume: false })} maskClosable={true}>
                            <div className="modal_panel" onClick={(e) => e.stopPropagation()}>
                                <div style={{
                                    // // fontSize: '1.2rem',
                                    // fontWeight: 600,
                                    // textAlign: 'center',
                                    // marginBottom: '1.2rem',
                                    // color: '#333'
                                }}>
                                    风量调节
                                </div>
                                <div className="slider_panel" style={{ margin: '1.5rem  0 0rem 0' }}>
                                    <div className="slider_div" style={{ margin: '0' }}>
                                        {this.state.volume_loading && (
                                            <div style={{ textAlign: 'center', margin: '0 10px', height: 50, paddingTop: '1rem', paddingBottom: '1.5rem', color: '#999' }}>
                                                <i className="fa fa-spinner fa-spin" style={{ marginRight: '0.5rem' }}></i>
                                                风量调节中...
                                            </div>
                                        )}
                                        {/* <Slider className="slider" defaultValue={this.props.volume}
                                            value={this.props.volume}
                                            min={this.state.min_volume} max={this.state.max_volume}
                                            onChange={this.local_volume}
                                            onAfterChange={this.volume}
                                        /> */}
                                        {!this.state.volume_loading && (
                                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <button style={{ ...btnStyle, border: '1px solid #ccc', }} onClick={() => this.adjustVolume(-10)}>
                                                    <i className="fa fa-minus"></i>
                                                </button>
                                                <div style={{ flex: 1, margin: '0 10px', height: 50, alignItems: 'center' }}>
                                                    <div style={{ paddingTop: '1rem', paddingBottom: '1.5rem', alignItems: 'center' }}>
                                                        <Slider
                                                            className="slider"
                                                            value={this.props.volume}
                                                            min={this.state.min_volume}
                                                            max={this.state.max_volume}
                                                            step={5}
                                                            onChange={this.local_volume}
                                                            onAfterChange={this.volume}
                                                        />
                                                    </div>
                                                    <div style={{
                                                        width: '100%',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'flex-end'
                                                    }}>
                                                        <div style={{ width: '33.33%', fontSize: 15, color: '#aaa', textAlign: 'left' }}>{this.state.min_volume}</div>

                                                        <div style={{ textAlign: 'center' }}>
                                                            <div style={{ fontSize: 15, color: '#108EE9' }}>
                                                                {this.props.volume}
                                                            </div>
                                                        </div>

                                                        <div style={{ width: '33.33%', fontSize: 15, color: '#aaa', textAlign: 'right' }}>{this.state.max_volume}</div>
                                                    </div>
                                                </div>
                                                <button style={{
                                                    ...btnStyle,
                                                    backgroundColor: '#00A2E9',
                                                    color: 'white'
                                                }} onClick={() => this.adjustVolume(10)}><i className="fa fa-plus"></i></button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="slider_panel_2">
                                </div>
                                {/* preset 风速按钮区域 */}
                                <div style={{
                                    display: 'flex',
                                    gap: '0.6rem',
                                    padding: '0.6rem 0'
                                }}>
                                    {[
                                        { label: '低速', value: this.state.min_volume },
                                        { label: '中速', value: Math.round((this.state.min_volume + this.state.max_volume) / 2) },
                                        { label: '高速', value: this.state.max_volume },
                                    ].map((item) => {
                                        // 当前 preset 是否激活
                                        const active = Math.abs(this.props.volume - item.value) <= 1;

                                        return (
                                            <Button
                                                key={item.label}
                                                onClick={() => {
                                                    this.local_volume(item.value);
                                                    this.volume(item.value);
                                                }}

                                                type={active ? 'primary' : 'ghost'}
                                                inline size="small"
                                                style={{
                                                    flex: 1,

                                                }}
                                                className='am-button-borderfix'
                                            >
                                                {item.label}
                                            </Button>
                                        );
                                    })}
                                </div>

                            </div>
                        </Modal>
                    </div>
                    <div className="operation_panel_item" onClick={this.mode_panel}>
                        <ControlItem src={mode_name} text="模式" open={this.props.online} />
                        <Modal popup visible={this.state.show_mode} animationType="slide-up">
                            <div style={area_desc}>模式调节</div>
                            <div style={mode_operation_area}>
                                <Button type={this.props.work_mode == 'manual' ? 'primary' : 'ghost'} inline size="small"
                                    className='am-button-borderfix'
                                    style={{ margin: '0 1.5rem' }} onClick={() => {
                                        {
                                            if (this.props.work_mode !== 'manual') {
                                                this.mode_operate('manual')
                                            }
                                        }
                                    }}>手动</Button>
                                <Button type={this.props.work_mode === 'sleep' ? 'primary' : 'ghost'} inline size="small"
                                    className='am-button-borderfix'
                                    style={{ margin: '0 1.5rem' }} onClick={() => {
                                        {
                                            if (this.props.work_mode !== 'sleep') {
                                                this.mode_operate('sleep')
                                            }
                                        }
                                    }}>睡眠</Button>
                                <Button type={this.props.work_mode === 'auto' ? 'primary' : 'ghost'} inline size="small"
                                    className='am-button-borderfix'
                                    style={{ margin: '0 1.5rem' }} onClick={() => {
                                        this.mode_operate('auto')
                                    }}>自动</Button>
                            </div>
                        </Modal>
                    </div>
                </div>
                <div className="separate_div_2"></div>
                <div className="operation_panel_row">
                    <div className="operation_panel_item" onClick={this.state.show_lightPanel ? this.light_panel_onOff : this.light_panel}>
                        <ControlItem src="fa fa-desktop" text="屏显"
                            open={this.props.online && this.state.lightPanelOnOff} />
                        <Modal popup visible={this.state.show_light} animationType="slide-up">
                            <div className="modal_panel">
                                <div className="slider_panel">
                                    <div className="slider_text">亮度调节</div>
                                    <div className="slider_div">
                                        <Slider className="slider" defaultValue={this.props.light}
                                            value={this.props.light}
                                            min={this.state.min_light} max={this.state.max_light}
                                            step={this.state.step}
                                            onChange={(e) => {
                                                this.local_light(e);
                                            }}
                                            onAfterChange={(e) => {
                                                this.light(e);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="slider_panel_2">
                                    <div className="slider_text"></div>
                                    <div className="slider_div_2">
                                        <div style={min_volume}>暗</div>
                                        <div style={current_volume}>{this.props.light}</div>
                                        <div style={max_volume}>亮</div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="operation_panel_item" onClick={this.heat_panel}>
                        <ControlItem src={heat_class[this.props.heat]} text="辅热" open={this.props.heat != 0} />
                        <Modal popup visible={this.state.show_heat} animationType="slide-up">
                            <div style={area_desc}>辅热调节</div>
                            <div style={mode_operation_area}>
                                {operation_list}
                            </div>
                        </Modal>
                    </div>
                    {this.props.lock_is_present &&
                        <div className="operation_panel_item" onClick={this.lock_operate}>
                            <ControlItem src="fa fa-child" text="童锁" open={this.props.lock === 1} />
                        </div>
                    }
                    {!this.props.lock_is_present &&
                        <div className="operation_panel_item" >
                        </div>
                    }
                </div>
            </div>
        );
    }

}

export default OperationPanel;
